export default __webpack_public_path__ + "static/media/Espace enseignant.95b31ce8.mp4";